import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'

export const CreditScore = ({ textTitle, text }) => {
  return (
    <div style={{ padding: 12, boxShadow: '0px 10px 12px rgba(0, 0, 0, 0.2)' }}>
      <Element
        elementName="p"
        style={{
          fontWeight: 600,
          lineHeight: '16px',
          color: '#191D25',
          paddingBottom: 12,
        }}
      >
        <Translate value={textTitle} />
      </Element>
      <Element elementName="p" style={{ lineHeight: '16px', color: '#3A414B' }}>
        {text}
      </Element>
    </div>
  )
}
